import { Vue, Component, Prop } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import bindClassDialog from '@/views/components/newDisplayConfig/bindClassDialog';
import { noop } from '@/util';

@DialogFactory
@Component({
  components: {},
  mixins: [style],
})
export default class AddSizeMapping extends IPSDialog {
  formData = {
    originName: '',
    contrastName: '',
    attrList: [],
  };

  $refs: {
    form: ElForm;
  };

  rules = {
    originName: [{ required: true, message: ' ', trigger: ['change', 'blur'] }],
    contrastName: [{ required: true, message: ' ', trigger: ['change', 'blur'] }],
    attrList: [{ required: true, message: '请选择分类', trigger: ['change', 'blur'] }],
  };

  attributeListStore = [];

  width = '700px';

  title = '自定义尺码对照表';

  onSelectedClass() {
    const defaultCheckedKeys = this.formData.attrList.flatMap(v => v.attrValues.split(','));
    bindClassDialog.open({ defaultCheckedKeys }).then((result) => {
      let attrList = [];
      result = result.filter((v) => {
        return v.isLeafe;
      });
      const attrCode = Array.from(new Set(result.map(vl => vl.class_code)));
      attrList = attrCode.map((v) => {
        return {
          attrCode: v,
          attrValues: result
            .filter(val => val.class_code === v)
            .map(vl => vl.value_no)
            .join(','),
        };
      });
      this.formData.attrList = attrList;
    }, noop);
  }

  computedClassName(val: { attrCode: string; attrValues: string }): string {
    val = Object.assign({}, { attrCode: '', attrValues: '' }, val);
    const parentAttr = this.attributeListStore.find(v => v.class_code === v.value_no && v.class_code && val.attrCode === v.class_code);
    const parentName = parentAttr ? parentAttr.class_name : '';
    const attrValues = val.attrValues.split(',');
    const childrenName = this.attributeListStore
      .filter(v => attrValues.includes(v.value_no))
      .map(vl => vl.value_name)
      .join('、');
    return `${parentName} - ${childrenName}`;
  }

  removeClass(i) {
    this.formData.attrList.splice(i, 1);
  }

  beforeConfirm() {
    this.$refs.form.validate((result) => {
      if (result) {
        IPSService.sizeMappingSave({
          postParams: this.formData,
        }).then(
          (response) => {
            this.$emit('result');
            this.$emit('hidden');
          },
          () => {
            this.confirmloading = false;
          },
        );
      } else {
        this.confirmloading = false;
      }
    });
  }

  renderContent(h) {
    return (
      <el-form ref="form" props={{ model: this.formData }} lable-position="left" label-width="120px" rules={this.rules} class="add-size-form">
        <el-form-item prop="originName" label="源尺码名称">
          <el-input v-model={this.formData.originName} placeholder="例：男US" class="wid-80" />
        </el-form-item>
        <el-form-item prop="contrastName" label="对照码名称">
          <el-input v-model={this.formData.contrastName} placeholder="例：EUR" class="wid-80" />
        </el-form-item>
        <el-form-item prop="attrList" label="绑定分类">
          <span class="scopeSpan" onClick={this.onSelectedClass.bind(this)}>
            请选择
          </span>
          <p class="tip blockTip">
            <span class="text-red">*&nbsp;</span>请仅选择【品牌】【大类】及【性别】三个类别，其中【大类】请单选。
          </p>
          <div>
            {this.formData.attrList.map((v, index) => {
              return (
                <div class="class-name" key={index}>
                  <el-tooltip class="item" effect="light" content={this.computedClassName(v)} placement="top-start">
                    <span>{this.computedClassName(v)}</span>
                  </el-tooltip>
                  <i class="el-icon-error delete r-ml-48" onClick={this.removeClass.bind(this, index)} />
                </div>
              );
            })}
          </div>
        </el-form-item>
      </el-form>
    );
  }
}
